.contentPane {
  display: flex;
  flex: 1;
  height: 100%;
  margin-left: 8px;
  margin-right: 8px;
  flex-direction: column;
  overflow: auto;
}

.splitterContainer {
  height: 100%;
}
